module.exports = __webpack_public_path__ + "img/team_philippe.6f78daad.jpg";